import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {Breadcrumb, Button, Form, Input, Select, Space, Spin} from "antd";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import DB_News_Mailing from "../../../database/admin/news_mailing";
import BackButton from "../../tech/back_button";


export const EditNewsMailing = () => {
    const {mailing_id} = useParams();
    const {token, setToken} = useContext(Context);
    const {t} = useTranslation();
    const {getNewsMailing, sendNewsMailing} = DB_News_Mailing(token)
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);

    useEffect(() => {
        window.scroll(0, 0)

        if (mailing_id === 'new') {
            setWait(false)
        } else {
            getNewsMailing(mailing_id)
                .then(res => {
                    form.setFieldsValue({
                        date: res.data.date,
                        type: res.data.types,
                        subject: res.data.subject,
                        text: res.data.text,
                    })
                    setWait(false);
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }
    }, [])

    const onFinish = (values) => {
        setWait(true);

        const formData = new FormData();
        formData.append('type', values["type"]);
        formData.append('subject', values["subject"]);
        formData.append('text', values["text"]);


        sendNewsMailing(formData)
            .then(res => {
                if (res.status === 200) {
                    navigate("/site/admin/mailing", {replace: true});
                } else {
                    errorConnect();
                }
            })
            .catch(e => {
                // if (e.request.status === 403) {
                //     setToken(null)
                // } else {
                //     setWait(false)
                //     errorConnect()
                // }
            });


    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('show_mailing')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>


                {/*<PageHeader*/}
                {/*    className="site-page-header"*/}
                {/*    onBack={() => window.history.back()}*/}
                {/*    title={mailing_id === 'new' ? t('new_mailing') : t('show_mailing')}*/}
                {/*    // subTitle="This is a subtitle"*/}
                {/*    breadcrumb={*/}
                {/*        <Breadcrumb>*/}
                {/*            <Breadcrumb.Item>*/}
                {/*                <Link to="/admin/mailing">{t('news_mailing')}</Link>*/}
                {/*            </Breadcrumb.Item>*/}
                {/*            <Breadcrumb.Item>*/}
                {/*                {mailing_id === 'new' ? t('new_mailing') : t('show_mailing')}*/}
                {/*            </Breadcrumb.Item>*/}
                {/*        </Breadcrumb>*/}
                {/*    }*/}
                {/*    extra={[*/}
                {/*        mailing_id === 'new' ?*/}
                {/*            <Button type={"primary"} htmlType="submit" form={"form"} key='2'>{t('save')}</Button> : null*/}
                {/*    ]}*/}
                {/*/>*/}


                <Form
                    form={form}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 10}}
                    layout={"vertical"}
                    onFinish={onFinish}
                    autoComplete="off"
                    id={"form"}
                >
                    <Form.Item style={{marginBottom: '10pt'}}
                               name="type"
                               label={t('type')}
                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            disabled={mailing_id !== 'new'}
                        >
                            <Select.Option key={1} value={1} name={t('all')}>{t('all')}</Select.Option>
                            <Select.Option key={2} value={2} name={t('developers')}>{t('developers')}</Select.Option>
                            <Select.Option key={3} value={3} name={t('managers')}>{t('managers')}</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="subject"
                               label={t('subject')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('subject').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Input.TextArea
                            autoSize={{
                                minRows: 5
                            }}
                            disabled={mailing_id !== 'new'}/>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="text"
                               label={t('text')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('text').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Input.TextArea
                            autoSize={{
                                minRows: 20
                            }}
                            disabled={mailing_id !== 'new'}/>
                    </Form.Item>


                </Form>
            </div>
            <Outlet/>
        </Spin>
    )
}